import React, { useState } from 'react';
import { Modal, Form, Input, Button,message} from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone,UnlockTwoTone,SendOutlined,CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { restPDVPassword} from "./../../services";

const ResetUPassword = ({ user,visible, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {

    console.log(user);
    console.log(values);
    values.user_id = user.id;
    try {
      setLoading(true);
      // Call your API here with form data
     const rdata = await restPDVPassword(values);

     console.log(rdata);

     if(rdata.status=="success"){
      message.success(rdata.message);
       form.resetFields();
       onClose();

     } else {
        message.warning(rdata.message);
     }


     
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const validatePassword = (_, value) => {
    const password = form.getFieldValue('password');
    if (value && value !== password) {
      return Promise.reject(new Error('The two passwords that you entered do not match!'));
    }
    return Promise.resolve();
  };

  return (
    <Modal
      title={<><UnlockTwoTone />  {user.name} - Reset Password </> }
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          label="New Password"
          name="password"
          rules={[
            { required: true, message: 'Please enter your new password!' },
            { min: 6, message: 'Password must be at least 6 characters long!' },
          ]}
        >
          <Input.Password
            placeholder="Enter new password"
            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item
          label="Confirm Password"
          name="confirmpassword"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Please confirm your new password!' },
            { validator: validatePassword },
          ]}
        >
          <Input.Password
            placeholder="Confirm new password"
            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>
        <Form.Item >

          <Button  type="primary" icon={<SendOutlined />} htmlType="submit" loading={loading}>
            Reset Password
          </Button>
            <span> </span>  
           <Button  type="default"   onClick={onClose}  >
           Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ResetUPassword;
